import { Component, Prop, h } from '@stencil/core';

@Component({
	shadow: true,
	styleUrl: 'zds-divider.scss',
	tag: 'zds-divider',
})
export class ZdsDivider {
	@Prop({ reflect: true }) light: boolean = false;
	@Prop() vertical: boolean = false;

	render() {
		return <hr class="zds-divider" />;
	}
}
